export default __webpack_public_path__ + "static/media/overview-img.335c467f.svg";